import { SvrConn } from "../utils/axios/index";

//-------------------
const getConsultAll = async () => {
  let res = {};
  try 
   {
     res = await SvrConn.get("/api/office/getofficeall");
   } 
   catch (Error) 
   {
     res = Error;
   }
  return res;
};

//-------Consulta un medico en un area
const getConsultInt = async (AreaId, ConsultId) => {
  let res = {};
  try {
    res = await SvrConn.post("/api/office/getofficeint", {
      AreaId,
      ConsultId,
    });
  } catch (Error) {
    res = Error;
  }
  return res;
};

const ActualizaConsult = async (data) => {
  let res = {};
  try {
    res = await SvrConn.post("/api/office/setactualizaoffice", data);
  } catch (Error) {
    res = Error;
  }
  return res;
};

//---
const getConsultArea = async (AreaId) => {
  let res = {};
  try {
    res = await SvrConn.post("/api/office/getofficearea", {
      AreaId,
    });
  } catch (Error) {
    res = Error;
  }
  return res;
};

//----
const updatePuestoTrabajo = async (data) => {
  let res = {};
  try {
    res = await SvrConn.post("/api/office/updatepuestotrabajo", data);
  } catch (Error) {
    res = Error;
  }
  return res;
};


export {getConsultAll, getConsultInt, ActualizaConsult, getConsultArea, updatePuestoTrabajo}